import React, { FC } from 'react'

const Noop: FC = ({ children }: { children: React.ReactNode | undefined }) => (
  <>{children}</>
)

export default Noop
